import { useGetDemoQuery } from '@carboncopyco/data';
import type { IDemo } from '@carboncopyco/types';
import { useParams } from 'react-router-dom';
import { useLinksPermissions } from '../../utils/hooks/useLinksPermissions';
import { ActivitiesTab } from './ActivitiesTab';
import { type DemoPageProps, DemoPageProvider } from './DemoPageContext';
import { DemoPageSidebar } from './DemoPageSidebar';
import { HistoryTab } from './HistoryTab';
import { LinksTab } from './LinksTab';
import { OverviewTab } from './OverviewTab';
import { PresentationsTab } from './PresentationsTab';
import { SpeakerNotesTab } from './SpeakerNotesTab';
import { UpdateDemoIndication } from './UpdateDemoIndication';
import type { DemoPageTab } from './types';

const componentByTabId = (demo: IDemo, isSharing?: boolean) => ({
  overview: <OverviewTab demo={demo} />,
  presentations: <PresentationsTab />,
  links: isSharing ? <LinksTab /> : null,
  activity: <ActivitiesTab />,
  history: <HistoryTab />,
  'speaker-notes': <SpeakerNotesTab />,
});

export const DemoPage = (props: DemoPageProps) => {
  const { demoId, organizationId, workspaceId } = props;
  const { getIsDemoShareable } = useLinksPermissions();
  const { tabId } = useParams<{ tabId: DemoPageTab }>();
  const { data: demo } = useGetDemoQuery({
    organizationId,
    workspaceId,
    id: demoId,
  });

  return (
    <DemoPageProvider {...props}>
      <div className="flex h-full w-full">
        <DemoPageSidebar />
        <div className="grow shrink-0">
          <UpdateDemoIndication />
          {tabId && componentByTabId(demo, getIsDemoShareable(demo))[tabId]}
        </div>
      </div>
    </DemoPageProvider>
  );
};
